import React, { Component } from 'react';

import get from 'lodash/get';
import WidgetPropTypes from '../types';
import Checkbox from '../../../components/UI/Checkbox/index.tsx';

export const WIDGET_NAME = 'accept_terms';

class AcceptTerms extends Component {
  constructor() {
    super();

    this.state = {
      accepted: false,
      error: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.accepted !== this.state.accepted) {
      if (this.state.accepted) {
        this.props.shouldEnable('accept_terms', true);
      } else {
        this.props.shouldEnable('accept_terms', false);
      }
    }
  }

  planChangesTermsAndConditionsHandling(planPricingName) {
    let termsConditionsResult;
    if (planPricingName === 'invest') {
      termsConditionsResult =
        this.props.app.planChangesTermsAndConditions &&
        get(this.props, 'app.answers.setPlan.pricingPlanName') &&
        this.props.app.answers.setPlan.pricingPlanName !== 'standard';
      return termsConditionsResult;
    }
    if (planPricingName === 'standard') {
      termsConditionsResult =
        !this.props.app.planChangesTermsAndConditions ||
        (get(this.props, 'app.answers.setPlan.pricingPlanName') &&
          this.props.app.answers.setPlan.pricingPlanName === 'standard') ||
        (this.props.app.planChangesTermsAndConditions &&
          !get(this.props, 'app.answers.setPlan.pricingPlanName'));
      return termsConditionsResult;
    }
  }

  getCheckBoxLabel() {
    const federalSavingsText = ' and the Community Federal Savings Bank ';
    const cardholderAgreement = (
      <a
        data-e2e="cardholder-agreement"
        target="_blank"
        href={`https://greenlight.com/cardholder`}
      >
        Cardholder Agreement
      </a>
    );
    const pricing = (
      <a
        data-e2e="pricing-legal"
        target="_blank"
        href="https://greenlight.com/fee-disclosures-load-limits"
      >
        Pricing
      </a>
    );
    const privacyStatement = (
      <a
        data-e2e="cfsb-privacy-policy"
        target="_blank"
        href="https://www.cfsb.com/privacy/"
      >
        Privacy Statement
      </a>
    );

    // select plan does not have option to invest so it uses different copy for terms agreement
    if (get(this.props, 'app.answers.setPlan.pricingPlanName') === 'select') {
      return (
        <>
          I accept the Greenlight {cardholderAgreement}, {pricing},{' '}
          {federalSavingsText}
          {privacyStatement} and I am providing my Personal Information above to
          enable the verification of my identity .
        </>
      );
    } else {
      return (
        <>
          I am providing my Personal Information above to enable the
          verification of my identity and I accept the Greenlight{' '}
          {cardholderAgreement}, {pricing},{' '}
          <a
            data-e2e="advisory-agreement"
            target="_blank"
            href={`https://greenlight.com/advisoryagreement`}
          >
            Investing Agreement
          </a>
          ,{' '}
          <a
            data-e2e="drivewealth-agreement"
            target="_blank"
            href={`https://legal.drivewealth.com/customer-account-agreement?lang=en_US`}
          >
            DriveWealth Customer Agreement
          </a>
          , {federalSavingsText}
          {privacyStatement}.
        </>
      );
    }
  }

  render() {
    const { changeAnswerValue, widget, toggles } = this.props;
    return (
      <>
        <Checkbox
          id="accept-terms"
          checked={this.state.accepted}
          onChange={() => {
            changeAnswerValue(widget, !this.state.accepted);
            this.setState({ accepted: !this.state.accepted });
          }}
          onClick={this.props.onClick}
          data-e2e="accept-checkbox"
          label={this.getCheckBoxLabel()}
        />
      </>
    );
  }
}

AcceptTerms.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired
};

export default AcceptTerms;
